module.exports = __webpack_public_path__ + "img/6.270de07.270de072.png";